// extracted by mini-css-extract-plugin
export default {"formField":"text-editor_formField__hdeW+","errorWrapper":"text-editor_errorWrapper__lhyYy"};